export default __webpack_public_path__ + "static/clutch-generative-ai-logo-9eb05f10ed713e3b2458a20ae968a22b.svg";